module.exports = __webpack_public_path__ + "static/media/304.6261b129.webp";